import { InjectionToken } from '@angular/core';
import { LogoConfig } from '../../models/logo-config/logo-config.model';

export const LOGO = new InjectionToken<LogoConfig>('logo');
